import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card-house__wrapper"
}
const _hoisted_2 = { class: "card-house__image-wrapper" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "card-house__body" }
const _hoisted_5 = { class: "card-house__body-title" }
const _hoisted_6 = { class: "card-house__body-title-hl" }
const _hoisted_7 = {
  key: 0,
  class: "card-house__body-list"
}
const _hoisted_8 = {
  key: 0,
  class: "card-house__body-list-item"
}
const _hoisted_9 = { class: "card-house__body-list-item-value" }
const _hoisted_10 = { class: "card-house__body-list-item" }
const _hoisted_11 = { class: "card-house__body-list-item-value" }
const _hoisted_12 = {
  key: 1,
  class: "card-house__body-list-item"
}
const _hoisted_13 = {
  key: 1,
  class: "card-house__body-price"
}
const _hoisted_14 = {
  key: 0,
  class: "card-house__body-price-set"
}
const _hoisted_15 = {
  key: 0,
  class: "card-house__body-price-set"
}
const _hoisted_16 = {
  key: 1,
  class: "card-house__body-price-set"
}
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "card-house__body-price-value" }
const _hoisted_19 = {
  key: 2,
  class: "card-house__body-price-set"
}
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { class: "card-house__body-price-value" }
const _hoisted_22 = {
  key: 1,
  class: "card-house__void"
}
const _hoisted_23 = { class: "card-house-discount__wrapper" }
const _hoisted_24 = { class: "card-house-discount__small-text" }
const _hoisted_25 = { class: "card-house-discount__action-text" }

import { computed, ref } from 'vue';
import LandStatus from '../commons/LandStatus.vue';
import { landPlotStore } from '@/store/modules/LandPLot';
import { cardSettingsStore } from '@/store/modules/CardSettings';
import { cashSpacer } from '@/helpers/cashHelpers';
import { getURL } from '@/helpers/routeHelpers';
import { switchCostLabel } from '@/helpers/costHelpers';


export default /*@__PURE__*/_defineComponent({
  __name: 'CardHouse',
  setup(__props) {

const houseCard = ref<HTMLElement | null>(null);
const isOverTheEdge = ref(false);

const isDiscount = computed(() => {
    return card.value &&
        Object.keys(card.value).length &&
        card.value.discount.value
        ? true
        : false;
});

const statusCardHouseShow = computed(() => {
    return cardSettingsStore.STATUS_CARD_HOUSE_SHOW;
});

const objectStyle = computed(() => {
    const ARROW_HEIGHT = 8;
    const {
        x,
        y,
        width: widthPath,
        top: topPath,
        height: heightPath,
    } = position.value;
    let widthCard = 0;
    let heightCard = 0;
    let top = y;
    let left = x + widthPath / 2;

    if (houseCard.value && houseCard.value instanceof Element) {
        widthCard = houseCard.value.clientWidth;
        heightCard = houseCard.value.clientHeight;

        isOverTheEdge.value = topPath - heightCard - ARROW_HEIGHT < 0;

        left = left - widthCard / 2;

        if (isOverTheEdge.value) {
            top = top + heightPath + ARROW_HEIGHT;
        } else {
            top = top - heightCard - ARROW_HEIGHT;
        }
    }

    return {
        left: `${left}px`,
        top: `${top}px`,
        opacity: statusCardHouseShow.value ? '1' : '0',
    };
});

const card = computed(() => {
    return landPlotStore.LAND_PLOT_CARD_MINI;
});

const position = computed(() => {
    return cardSettingsStore.POSITION_CARD_HOUSE;
});

const isSold = computed(() => {
    return (
        (!card.value?.price && !card.value?.newPrice) ||
        card.value.status === 'occupied'
    );
});

function formatedCost(price: number) {
    return cashSpacer(price, ' ');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['card-house', { 'card-house--over-the-edge': isOverTheEdge.value }]),
    style: _normalizeStyle(objectStyle.value),
    ref_key: "houseCard",
    ref: houseCard
  }, [
    (card.value && Object.keys(card.value).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (card.value.imgUrl)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "card-house__image",
                  src: card.value.imgUrl,
                  alt: card.value.title
                }, null, 8, _hoisted_3))
              : _createCommentVNode("", true)
          ]),
          _createVNode(LandStatus, {
            class: "card-house__status",
            landPlotStatus: card.value.status
          }, null, 8, ["landPlotStatus"]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h2", _hoisted_5, [
              _createTextVNode(_toDisplayString(card.value.withHouse ? 'Проект' : '') + " ", 1),
              _createElementVNode("span", _hoisted_6, _toDisplayString(card.value.title), 1),
              _createTextVNode(_toDisplayString(card.value.params.streetName
                            ? `, ${card.value.params.streetName}`
                            : '') + _toDisplayString(card.value.params.streetNumber
                            ? `, ${card.value.params.streetNumber}`
                            : ''), 1)
            ]),
            (card.value.params && Object.keys(card.value.params).length)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
                  (card.value.withHouse)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                        _cache[0] || (_cache[0] = _createElementVNode("p", { class: "card-house__body-list-item-label" }, " Площадь дома, м2 ", -1)),
                        _createElementVNode("p", _hoisted_9, _toDisplayString(card.value.params.areaHouse), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("li", _hoisted_10, [
                    _cache[1] || (_cache[1] = _createElementVNode("p", { class: "card-house__body-list-item-label" }, " Площадь участка, соток ", -1)),
                    _createElementVNode("p", _hoisted_11, _toDisplayString(card.value.params.areaPlot), 1)
                  ]),
                  (card.value.params.houseOut)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                        _cache[2] || (_cache[2] = _createElementVNode("p", { class: "card-house__body-list-item-label" }, " Срок сдачи ", -1)),
                        _createElementVNode("p", null, _toDisplayString(card.value.params.houseOut), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (isSold.value || card.value.price || card.value.newPrice)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  (isSold.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, _cache[3] || (_cache[3] = [
                        _createElementVNode("div", { class: "card-house__body-price-value card-house__body-price-value--sold" }, " Продано ", -1)
                      ])))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (card.value.price && card.value.price === 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, _cache[4] || (_cache[4] = [
                              _createElementVNode("div", { class: "card-house__body-price-value" }, " Скоро в продаже ", -1)
                            ])))
                          : _createCommentVNode("", true),
                        (card.value.price && card.value.price !== 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                              _createElementVNode("div", {
                                class: "card-house__body-price-label",
                                innerHTML: `Цена с ${_unref(switchCostLabel)(card.value.price, [
                                `<b
                                >чистовой отделкой</b
                            >`,
                                `отделкой <b>Black box</b>`,
                            ])}`
                                
                              }, null, 8, _hoisted_17),
                              _createElementVNode("div", _hoisted_18, _toDisplayString(`${formatedCost(card.value.price)} ₽`), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (card.value.newPrice)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                              _createElementVNode("div", {
                                class: "card-house__body-price-label",
                                innerHTML: `Цена с ${_unref(switchCostLabel)(
                                card.value.newPrice || 0,
                                [
                                    `<b
                                >чистовой отделкой</b
                            >`,
                                    `отделкой <b>White box</b>`,
                                ],
                            )}`
                                
                              }, null, 8, _hoisted_20),
                              _createElementVNode("div", _hoisted_21, _toDisplayString(`${formatedCost(card.value.newPrice || 0)} ₽`), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_22, _cache[5] || (_cache[5] = [
          _createElementVNode("p", null, "Нет данных", -1)
        ]))),
    _withDirectives(_createElementVNode("div", {
      class: "card-house-discount card-house__discount",
      style: _normalizeStyle({
                'background-image': `url(${_unref(getURL)()}/${require('@/assets/img/svg/bookmark.svg')})`,
            })
    }, [
      _createElementVNode("div", _hoisted_23, [
        _withDirectives(_createElementVNode("div", _hoisted_24, " Скидка ", 512), [
          [_vShow, isDiscount.value]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_25, " Акция ", 512), [
          [_vShow, !isDiscount.value]
        ]),
        _withDirectives(_createElementVNode("div", { class: "card-house-discount__big-text" }, _toDisplayString(card.value && Object.keys(card.value).length && card.value.discount.value
                            ? card.value.discount.value
                            : '') + "% ", 513), [
          [_vShow, card.value && Object.keys(card.value).length && card.value.discount.value
                    ]
        ])
      ])
    ], 4), [
      [_vShow, card.value &&
            Object.keys(card.value).length &&
            (card.value.discount.value || card.value.action)
            ]
    ])
  ], 6))
}
}

})